import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, apiError } from "../lib/api";

// Admin: paid sessions that need a human decision (duplicate purchases) or a retry (unlinked).
export function PaymentsAttention() {
  const [data, setData] = useState({ duplicates: [], unlinked: [] });
  const [busy, setBusy] = useState(null);
  const load = () => api.get("/admin/payments/attention").then((r) => setData(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const act = async (sid, action, confirmMsg) => {
    if (confirmMsg && !window.confirm(confirmMsg)) return;
    setBusy(sid + action);
    try { await api.post(`/admin/payments/${sid}/${action}`); toast.success(action === "refund" ? "Refund issued via Stripe." : action === "keep" ? "Marked as kept." : "Fulfilment re-run."); load(); }
    catch (e) { toast.error(apiError(e)); }
    finally { setBusy(null); }
  };

  const pending = data.duplicates.filter((d) => d.refund_status === "pending");
  const reviewed = data.duplicates.filter((d) => d.refund_status !== "pending");
  if (!pending.length && !reviewed.length && !data.unlinked.length) return null;
  const money = (a) => `$${Number(a || 0).toFixed(2)}`;
  const when = (iso) => (iso || "").slice(0, 10);

  return (
    <div className="mb-12" data-testid="payments-attention">
      <p className="text-[11px] uppercase tracking-ultra text-accent mb-4">Payments needing attention</p>
      <div className="border border-line divide-y divide-line">
        {pending.map((d) => (
          <div key={d.session_id} className="p-4 text-sm flex flex-col sm:flex-row sm:items-center gap-3" data-testid={`duplicate-${d.session_id}`}>
            <div className="flex-1">
              <span className="text-ink">{d.email}</span> <span className="text-ink-soft">paid {money(d.amount)} again for {d.course_title} · {when(d.created_at)}</span>
              <p className="text-xs text-ink-soft mt-1">Duplicate purchase — already owned. No second enrolment was created.</p>
            </div>
            <div className="flex gap-2">
              <button data-testid={`refund-${d.session_id}`} disabled={!!busy} onClick={() => act(d.session_id, "refund", `Refund ${money(d.amount)} to ${d.email} via Stripe?`)}
                className="bg-ink text-bg px-4 py-2 text-[10px] uppercase tracking-[0.15em] hover:bg-[#33312E] disabled:opacity-60">Refund</button>
              <button data-testid={`keep-${d.session_id}`} disabled={!!busy} onClick={() => act(d.session_id, "keep")}
                className="border border-ink px-4 py-2 text-[10px] uppercase tracking-[0.15em] hover:bg-ink hover:text-bg disabled:opacity-60">Keep</button>
            </div>
          </div>
        ))}
        {data.unlinked.map((d) => (
          <div key={d.session_id} className="p-4 text-sm flex flex-col sm:flex-row sm:items-center gap-3" data-testid={`unlinked-${d.session_id}`}>
            <div className="flex-1">
              <span className="text-ink">{d.email || "unknown email"}</span> <span className="text-ink-soft">paid {money(d.amount)} for {d.course_title} · {when(d.created_at)}</span>
              <p className="text-xs text-ink-soft mt-1">Paid but access not yet granted. Re-run fulfilment.</p>
            </div>
            <button data-testid={`resolve-${d.session_id}`} disabled={!!busy} onClick={() => act(d.session_id, "resolve")}
              className="bg-ink text-bg px-4 py-2 text-[10px] uppercase tracking-[0.15em] hover:bg-[#33312E] disabled:opacity-60">Resolve</button>
          </div>
        ))}
        {reviewed.map((d) => (
          <div key={d.session_id} className="p-4 text-sm flex justify-between text-ink-soft" data-testid={`reviewed-${d.session_id}`}>
            <span>{d.email} · {d.course_title} · {money(d.amount)}</span>
            <span className="uppercase text-[10px] tracking-[0.15em]">{d.refund_status}{d.refund_id ? ` · ${d.refund_id}` : ""}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
